'use client'

import { Builder } from '@builder.io/react'

import { SmallFooter } from '@src/components/SmallFooter/SmallFooter'
import { defaults } from '@src/components/SmallFooter/SmallFooter.defaults'

Builder.registerComponent(SmallFooter, {
  name: 'SmallFooter',
  inputs: [
    {
      name: 'copyright',
      type: 'string',
      localized: true,
      defaultValue: defaults.copyright,
    },
    {
      name: 'links',
      type: 'list',
      localized: true,
      defaultValue: defaults.links,
      subFields: [
        {
          name: 'label',
          type: 'string',
          localized: true,
        },
        {
          name: 'href',
          type: 'string',
          localized: true,
        },
      ],
    },
    {
      name: 'badges',
      type: 'list',
      defaultValue: defaults.badges,
      subFields: [
        {
          friendlyName: 'Badge image',
          name: 'url',
          type: 'file',
          localized: true,
        },
        {
          name: 'altText',
          type: 'string',
          localized: true,
          defaultValue: 'Footer badge',
        },
      ],
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/border-bottom.svg',
})
